import { render, staticRenderFns } from "./draw3DPieCanvas.vue?vue&type=template&id=482288e2&scoped=true"
import script from "./draw3DPieCanvas.vue?vue&type=script&lang=js"
export * from "./draw3DPieCanvas.vue?vue&type=script&lang=js"
import style0 from "./draw3DPieCanvas.vue?vue&type=style&index=0&id=482288e2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482288e2",
  null
  
)

export default component.exports